<template>
  <footer class="v-footer">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <div class="c-fs-14 c-c-footer-grey content">
        <div class="content-wrap">
          <div class="c-d-f c-jc-sb cm-width c-c-footer-grey content-item">
            <div class="c-d-f c-fd-c">
              <img src="../assets/header/footer-logo.png" class="footer-logo-img">
              <div class="c-d-f c-ai-c c-mb-12 c-mt-60">
                <img src="../assets/header/icon1.png">
                <span class="c-ml-20">安徽高颐科技有限公司</span>
              </div>
              <div class="c-d-f c-ai-c c-mb-12">
                <img src="../assets/header/icon2.png">
                <span class="c-ml-20">4006-111-696</span>
              </div>
              <div class="c-d-f c-ai-c c-mb-12">
                <img src="../assets/header/icon3.png">
                <span class="c-ml-20">安徽省池州经济技术开发区电子信息产业园7楼</span>
              </div>
            </div>
            <div>
              <p class="c-fs-16 c-ff-m c-c-white c-mb-24 c-cs-p hover" @click="toUrl('/internetMonitor')">产品案例</p>
              <p class="c-mb-16 c-cs-p hover" v-for="item in productsList.slice(0, 6)" :key="item.name" @click="toUrl(item.link)">{{item.name}}</p>
            </div>
            <div>
              <p class="c-fs-16 c-ff-m c-c-white c-mb-24 c-op-0" @click="toUrl('/resolution')">1</p>
              <p class="c-mb-16 c-cs-p hover" v-for="item in productsList.slice(6)" :key="item.name" @click="toUrl(item.link)">{{item.name}}</p>
            </div>
            <div>
              <p class="c-fs-16 c-ff-m c-c-white c-mb-24 c-cs-p hover" @click="toUrl('/resolution')">解决方案</p>
              <p class="c-mb-16 c-cs-p hover" v-for="item in resolutionList" :key="item.name" @click="toUrl(item.link)">{{item.name}}</p>
            </div>
            <!-- <div>
              <p class="c-fs-16 c-ff-m c-c-white c-mb-24 c-cs-p hover" @click="toUrl('/support')">认证培训</p>
              <p class="c-mb-12 c-cs-p hover" v-for="item in supportList" :key="item.name" @click="toUrl(item.link)">{{item.name}}</p>
            </div> -->
            <!-- <div>
              <p class="c-fs-16 c-ff-m c-c-white c-mb-24 c-cs-p hover" @click="toUrl('/partners')">合作伙伴</p>
              <p class="c-mb-12 c-cs-p hover" v-for="item in partnersList" :key="item.name" @click="toChildUrl(item.link, item.isPage, 1)">{{item.name}}</p>
            </div> -->
            <div>
              <p class="c-fs-16 c-ff-m c-c-white c-mb-24 c-cs-p hover" @click="toUrl('/about')">关于我们</p>
              <p class="c-mb-16 c-cs-p hover" v-for="item in aboutList" :key="item.name" @click="toChildUrl(item.link, item.isPage, 2)">{{item.name}}</p>
            </div>
            <div class="c-d-f c-fd-c c-ai-c footer-code">
              <img src="../assets/header/QR-code.png">
              <!-- <p class="c-mt-20">email：joshua#quaee.com</p> -->
            </div>
          </div>
        </div>
        <div class="c-d-f c-jc-c copyright">
          <a class="c-cs-p hover" href="https://beian.miit.gov.cn" target="_black">皖ICP备18014328号-1</a>
          <!-- <p>copyright @ 2018 高颐科技有限公司</p> -->
        </div>
      </div>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <div class="c-d-f c-ai-c c-jc-c c-pl-24 c-pr-20 content-mobile">
        <div class="c-d-f c-jc-sa c-w-100">
          <img src="../assets/header/footer-logo.png">
          <div class="c-ml-36 footer-info">
            <div class="c-d-f c-mb-12">
              <img src="../assets/header/icon1.png">
              <p class="c-fs-12 c-ml-16 c-c-footer-grey-mobile">安徽高颐科技有限公司</p>
            </div>
            <div class="c-d-f c-mb-8">
              <img src="../assets/header/icon2.png">
              <p class="c-fs-12 c-ml-16 c-c-footer-grey-mobile">4006-111-696</p>
            </div>
            <div class="c-d-f">
              <img src="../assets/header/icon3.png" class="c-mt-4">
              <p class="c-fs-12 c-ml-16 c-lh-22 c-c-footer-grey-mobile">安徽省池州经济技术开发区电子信息产业园7楼</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import { productsList, resolutionList, supportList, partnersList, aboutList } from '../constants/header.constants'
export default {
  name: 'p-footer',
  data () {
    return {
      productsList: productsList,
      resolutionList: resolutionList,
      supportList: supportList,
      aboutList: aboutList,
      partnersList: partnersList
    }
  },
  methods: {
    toUrl (url) {
      if (this.activedPath !== url) {
        this.$router.push(url)
      }
    },
    // pc footer合作伙伴和关于我们跳转
    toChildUrl (url, isPage = false, type) {
      if (type === 1 && !isPage) {
        if (this.activedPath !== '/partners') this.$router.push('/partners')
        setTimeout(() => {
          const distance = document.getElementById(url).offsetTop
          document.documentElement.scrollTop = distance - 120
          document.body.scrollTop = distance - 120
        }, 300)
      } else if (type === 2 && !isPage) {
        if (this.activedPath !== '/about') this.$router.push('/about')
        setTimeout(() => {
          const distance = document.getElementById(url).offsetTop
          document.documentElement.scrollTop = distance - 120
          document.body.scrollTop = distance - 120
        }, 300)
      } else {
        if (this.activedPath !== url) {
          this.$router.push(url)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.v-footer {
  color: $white;
  .content {
    background: url('../assets/index/footer.png') no-repeat;
    background-size: cover;
    .content-wrap {
      max-width: 1440px;
      padding-top: 86px;
      padding-bottom: 72px;
      margin: 0 auto;
      border-bottom: 1px solid rgba(255,255,255,0.25);;
      .content-item {
        width: 1180px;
        margin: 0 auto;
        .footer-logo-img {
          width: 240px;
        }
      }
    }
    .copyright {
      width: 1180px;
      margin: 0 auto;
      padding-top: 22px;
      padding-bottom: 22px;
      color: rgba(255,255,255,0.65);
    }
    .footer-code {
      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
      }
    }
    .hover {
        &:hover {
          color: $orange
        }
      }
  }
  .content-mobile {
    height: 162px;
    background: url('../assets/index/footer-m.png') no-repeat;
    background-size: cover;
    img {
      width: 107px;
      height: 26px;
      object-fit: contain;
    }
    .footer-info {
      img {
        width: 14px;
        height: 14px;
        object-fit: cover;
      }
    }
  }
}
</style>
